module.exports = __webpack_public_path__ + "static/media/borrowerlogin.6942d4a6.png";